import { animate, style, transition, trigger } from '@angular/animations';

export const FadeInLeft = trigger(
	'fadeInLeft', [
		transition(':enter', [
			style({ transform: "translateX(15px)", opacity: 0.5 }),
			animate('175ms ease-out', style({ transform: "none", opacity: 1 })),
		]),
		transition(':leave', [
			animate('225ms ease-in', style({ transform: "translateX(15px)", opacity: 0 })),
		]),
	]
)